import * as URLUtils from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import SearchMetadata from "views/logic/search/SearchMetadata";
const parseSearchUrl = URLUtils.qualifyUrl("/views/search/metadata");
const parseSearch = (search) => fetch("POST", parseSearchUrl, JSON.stringify(search)).then(
  (response) => SearchMetadata.fromJSON(response),
  () => void 0
);
export default parseSearch;
